module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.hasSomethingToShow) ? _c('div', {
    attrs: {
      "id": "StateListContainer"
    }
  }, [(_vm.reservationType !== '通常') ? _c('div', {
    staticClass: "inlineBlock",
    attrs: {
      "id": "reservationTypeIcon"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.reservationType) + "\n  ")]) : _vm._e(), _vm._v(" "), (_vm.hasConfTest) ? _c('div', {
    staticClass: "inlineBlock",
    attrs: {
      "id": "confirmTestIcon"
    }
  }, [_vm._v("\n    配布物\n  ")]) : _vm._e(), _vm._v(" "), (_vm.hasMessage()) ? _c('div', {
    staticClass: "inlineBlock",
    attrs: {
      "id": "hasMessage"
    }
  }, [_vm._v("\n    連絡有り\n  ")]) : _vm._e()]) : _vm._e()
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-4a78af74", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4a78af74"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/timetable/ReservationStates.vue
// module id = 709
// module chunks = 0